import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loadingCallLogs: false,
    loading: false,
    calls: [],
    selectedCall: {},
    inboundcalls: [],
    outboundcalls: [],
    callHistory: [],
    callLogId: null,
    callType: "",
    smsMarketingNumber: "",
    callsIsViewed: [],
    aptCallsIsViewed: [],
    communicationHistory: [],
}

const patientSlice = createSlice({
    name: "callogs",
    initialState,
    reducers: {
        updateCallLogs: (state, action) => {
            state.calls = action.payload
        },
        updateSelectedCallLogs: (state, action) => {
            state.selectedCall = action.payload
        },
        fetchInboundCalls: (state, action) => {
            state.inboundcalls = action.payload
        },
        fetchOutboundCalls: (state, action) => {
            state.outboundcalls = action.payload
        },
        updateCallHistory: (state, action) => {
            state.callHistory = action.payload || []
            state.loadingCallLogs = false
        },
        updateLoadingCallLogs: (state, action) => {
            state.loadingCallLogs = action.payload
        },
        updateCallIsViewed: (state, action) => {
            state.callsIsViewed = action.payload || []
        },
        updateAptCallIsViewed: (state, action) => {
            state.aptCallsIsViewed = action.payload || []
        },
        updateLoading: (state, action) => {
            state.loading = action.payload
        },
        updateCallLogId: (state, action) => {
            console.log(action.payload, "slkdfjsdlkf")
            state.callLogId = action.payload
        },
        updateCallType: (state, action) => {
            state.callType = action.payload
        },
        updateSmsMarketingNumber: (state, action) => {
            console.log(action.payload, "skdjfdlskjfls")
            state.smsMarketingNumber = action.payload
        },
        updateCommunicationHistory: (state, action) => {
            state.communicationHistory = action.payload
        },
    },
})

export const {
    updateCallLogs,
    updateSelectedCallLogs,
    fetchInboundCalls,
    fetchOutboundCalls,
    updateCallHistory,
    updateLoading,
    updateCallLogId,
    updateCallType,
    updateSmsMarketingNumber,
    updateCallIsViewed,
    updateAptCallIsViewed,
    updateLoadingCallLogs,
    updateCommunicationHistory,
} = patientSlice.actions

export default patientSlice.reducer
